import { render, staticRenderFns } from "./CardItensPedido.vue?vue&type=template&id=6fe96e52&"
import script from "./CardItensPedido.vue?vue&type=script&lang=js&"
export * from "./CardItensPedido.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports